import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBlock, ContentLeft, ContentTextLeft } from './styled';
import { BackButton } from '../styled';
import { BaseQuizProps } from 'containers/pages/courses-list/types';

const TeacherWelcome: FC<BaseQuizProps> = ({ back, title, link }) => {
    const { t } = useTranslation('pages/quiz');

    return (
        <ContentLeft>
            <ContentTextLeft>{t(`pages/quiz:${title}`)}</ContentTextLeft>
            <ButtonBlock>
                <BackButton forwardedAs={'a'} href={link}>
                    {t('next')}
                </BackButton>
                <BackButton onClick={back}>{t('pages/quiz:back')}</BackButton>
            </ButtonBlock>
        </ContentLeft>
    );
};

export default TeacherWelcome;
